(function () {
  function setOpen(btn, open) {
    if (!btn) return;
    var item = btn.closest('.opt-shop-all__item');
    var subId = btn.getAttribute('aria-controls');
    var sub = subId ? document.getElementById(subId) : null;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (item) item.classList.toggle('is-open', open);
    if (sub) {
      if (open) sub.removeAttribute('hidden');
      else sub.setAttribute('hidden', '');
    }
  }

  function closeOthers(fromBtn) {
    var root = fromBtn.closest('.opt-shop-all__panel') || fromBtn.closest('#opt-mobile-drawer') || document;
    root.querySelectorAll('.js-shop-all-toggle[aria-expanded="true"]').forEach(function (other) {
      if (other !== fromBtn) setOpen(other, false);
    });
  }

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest && evt.target.closest('.js-shop-all-toggle');
    if (!btn) return;
    evt.preventDefault();
    evt.stopPropagation();
    var open = btn.getAttribute('aria-expanded') === 'true';
    closeOthers(btn);
    setOpen(btn, !open);
    if (evt.detail) btn.blur();
  });

  document.addEventListener('keydown', function (evt) {
    if (evt.key !== 'Escape') return;
    var openBtns = document.querySelectorAll('.js-shop-all-toggle[aria-expanded="true"]');
    if (!openBtns.length) return;
    var last = openBtns[openBtns.length - 1];
    setOpen(last, false);
    last.focus();
  });
})();
